"use client";

import React, { useState } from "react";
import { logout } from "lib/api";
import type { LocaleOfStoreType } from "@beautypie/core";
import { LoginLink } from "../LoginLink";
import { container } from "./ProfileMenuContainer.css";
import { UserMenu } from "./UserMenu";
import { ProfileButton } from "./ProfileButton";

type Props = {
  locale: LocaleOfStoreType;
  isLoggedIn: boolean;
};

export const ProfileMenuContainer: React.FC<Props> = ({
  locale,
  isLoggedIn
}) => {
  const [showUserMenu, setShowUserMenu] = useState(false);

  const onProfileButtonClick = () => {
    setShowUserMenu(!showUserMenu);
  };

  const onLogout = async () => {
    await logout();
    window.location.reload();
  };

  return (
    <div className={container}>
      {isLoggedIn ? (
        <>
          <ProfileButton onClick={onProfileButtonClick} />
          {showUserMenu && (
            <UserMenu
              locale={locale}
              toggleUserMenu={onProfileButtonClick}
              onLogout={onLogout}
            />
          )}
        </>
      ) : (
        <LoginLink locale={locale} />
      )}
    </div>
  );
};
